import React from 'react';
import { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Loader } from '../../../common/components';
import TravelSchemeEditContainer from '../components/EditSchemePages/TravelSchemeEditContainer';
import SmartLuggageEditContainer from '../components/EditSchemePages/SmartLuggageEditContainer';
import PersonalAccidentEditContainer from '../components/EditSchemePages/PersonalAccidentEditContainer';
import { actions } from '../redux/ProductReducer';

const SchemeEditContainer = ({
  params,
  getProduct,
  getInsurer,
  location,
  getSchemeDetails,
}) => {
  const { productId, insurerId, schemeId } = params;
  const { product, insurer, schemeDetails, isSubmitting } = useSelector(
    (state) => state.productManagement,
  );

  const currentProductId = product?.data?.id;
  const currentInsurerId = insurer?.data?.id;
  const currentSchemeId = schemeDetails?.data?.id;
  // const currentSchemeId = scheme?.data?.id;

  const { pathname } = location;

  const isViewOnly = pathname.indexOf('/view-scheme') !== -1;

  useEffect(
    () => {
      if (!currentProductId || currentProductId !== productId) {
        getProduct(productId);
      }
    },
    [productId, currentProductId, getProduct],
  );

  useEffect(
    () => {
      if (insurerId && (!currentInsurerId || currentInsurerId !== insurerId)) {
        getInsurer(insurerId, ['schemes', 'schemes.scheme_group']);
      }
    },
    [currentInsurerId, insurerId, getInsurer],
  );

  useEffect(
    () => {
      if (schemeId && (!currentSchemeId || currentSchemeId !== schemeId)) {
        getSchemeDetails(schemeId);
      }
    },
    [currentSchemeId, schemeId, getSchemeDetails],
  );

  const productType = product?.data?.attributes?.product_type;

  const isReady =
    currentSchemeId &&
    currentProductId &&
    (insurerId ? currentInsurerId : true) &&
    currentSchemeId === schemeId;

  if (!isReady) {
    return <Loader />;
  }
  if (!productType) {
    return null;
  }

  if (productType === 'Leisure Travel Insurance') {
    return (
      <TravelSchemeEditContainer
        productId={productId}
        productType={productType}
        medicalQuestions={product?.data?.attributes?.metadata?.medical_declaration_questions}
        insurerId={insurerId}
        schemeId={schemeId}
        scheme={schemeDetails}
        isViewOnly={isViewOnly}
        baseUrl={`/admin/products/${productId}/insurers/${insurerId}`}
        isSubmitting={isSubmitting}
      />
    );
  }
  if (productType === 'Baggage Insurance') {
    return (
      <SmartLuggageEditContainer
        productId={productId}
        productType={productType}
        isViewOnly={isViewOnly}
        scheme={schemeDetails}
        baseUrl={`/admin/products/${productId}/`}
        isSubmitting={isSubmitting}
      />
    );
  }

  if (productType === 'Personal Accident Insurance') {
    return (
      <PersonalAccidentEditContainer
        productId={productId}
        productType={productType}
        isViewOnly={isViewOnly}
        scheme={schemeDetails}
        baseUrl={`/admin/products/${productId}/`}
        isSubmitting={isSubmitting}
      />
    );
  }

  return null;
};

export default connect(
  null,
  {
    getProduct: actions.getProduct,
    getInsurer: actions.getInsurer,
    getSchemeDetails: actions.getSchemeDetails,
  },
)(SchemeEditContainer);
